export const WORKFLOW_GROUPS = {
    A: {
        label: "Salesman",
        color: "#0369a1",
        bgColor: "#e0f2fe",
        borderColor: "#7dd3fc",
    },
    B: {
        label: "Design & Drafting",
        color: "#800020",
        bgColor: "#fde8e8",
        borderColor: "#c62828",
    },
    C: {
        label: "Customer",
        color: "#7c3aed",
        bgColor: "#ede9fe",
        borderColor: "#c4b5fd",
    },
    D: {
        label: "Purchasing",
        color: "#0f766e",
        bgColor: "#ccfbf1",
        borderColor: "#5eead4",
    },
    E: {
        label: "Production",
        color: "#b45309",
        bgColor: "#fef3c7",
        borderColor: "#fcd34d",
    },
    F: {
        label: "Installation",
        color: "#15803d",
        bgColor: "#dcfce7",
        borderColor: "#86efac",
    },
    G: {
        label: "Order Overview",
        color: "#64748b",
        bgColor: "#f1f5f9",
        borderColor: "#cbd5e1",
    },
};

export const WORKFLOW_STEPS = {
    A1: {
        code: "A1",
        group: "A",
        title: "Create New User",
        subtitle: "Register customer account",
        path: "/newUser",
        processStepId: null,
        roles: "all",
        subSteps: [
            { code: "A1.1", title: "Name" },
            { code: "A1.2", title: "IC / company registration" },
            { code: "A1.3", title: "TIN" },
            { code: "A1.4", title: "Email" },
            { code: "A1.5", title: "Phone number" },
            { code: "A1.6", title: "Password" },
            { code: "A1.7", title: "Marketer" },
            { code: "A1.8", title: "Remarks" },
            { code: "A1.9", title: "Create user" },
        ],
    },
    A2: {
        code: "A2",
        group: "A",
        title: "Open Invoice",
        subtitle: "Create order at POS",
        path: "/pos",
        processStepId: 1,
        roles: "all",
        subSteps: [
            { code: "A2.1", title: "Select products" },
            { code: "A2.2", title: "Product category" },
            { code: "A2.3", title: "Price" },
            { code: "A2.4", title: "Add to cart" },
            { code: "A2.5", title: "Product information" },
            { code: "A2.6", title: "Discount" },
            { code: "A2.7", title: "Expenses" },
            { code: "A2.8", title: "Commission" },
            { code: "A2.9", title: "Customer details" },
            { code: "A2.10", title: "Date of issue" },
            { code: "A2.11", title: "Customer" },
            { code: "A2.12", title: "CO number" },
            { code: "A2.13", title: "Deposit" },
            { code: "A2.14", title: "Second payment" },
            { code: "A2.15", title: "Third payment" },
            { code: "A2.16", title: "Salesman" },
            { code: "A2.17", title: "Address line 1" },
            { code: "A2.18", title: "Address line 2" },
            { code: "A2.19", title: "Postal code" },
            { code: "A2.20", title: "City" },
            { code: "A2.21", title: "State" },
            { code: "A2.22", title: "Billing address line 1" },
            { code: "A2.23", title: "Billing address line 2" },
            { code: "A2.24", title: "Billing postcode" },
            { code: "A2.25", title: "Billing city" },
            { code: "A2.26", title: "Billing state" },
            { code: "A2.27", title: "Estimated installation days" },
            { code: "A2.28", title: "Remark" },
            { code: "A2.29", title: "Leakage warranty" },
            { code: "A2.30", title: "ACP warranty" },
            { code: "A2.31", title: "Structure warranty" },
            { code: "A2.32", title: "Glass warranty" },
            { code: "A2.33", title: "Polycarbonate warranty" },
            { code: "A2.34", title: "Metal deck warranty" },
            { code: "A2.34.1", title: "Aluminium C-Bond warranty" },
            { code: "A2.35", title: "Extra warranty" },
            { code: "A2.36", title: "Payment proof" },
            { code: "A2.37", title: "SST included" },
            { code: "A2.38", title: "Skip approval" },
            { code: "A2.39", title: "Submit order" },
        ],
    },
    A3: {
        code: "A3",
        group: "A",
        title: "Customer Sign",
        subtitle: "Blueprint approval",
        path: null,
        processStepId: 3,
        roles: "all",
        subSteps: [
            { code: "A3.1", title: "Order" },
            { code: "A3.2", title: "Customer" },
            { code: "A3.3", title: "Customer approve" },
            { code: "A3.4", title: "Approval requirements" },
            { code: "A3.5", title: "Tick all drafts" },
            { code: "A3.6", title: "Provide signature" },
            { code: "A3.7", title: "Draft files" },
            { code: "A3.8", title: "Draft selection" },
            { code: "A3.9", title: "Customer signature" },
            { code: "A3.10", title: "Clear signature" },
            { code: "A3.11", title: "Saved signature" },
        ],
    },
    C2: {
        code: "C2",
        group: "C",
        title: "Customer satisfaction survey",
        subtitle: "Survey & sign off",
        path: null,
        processStepId: 9,
        roles: "customer",
        subSteps: [
            { code: "C2.1", title: "Pricing" },
            { code: "C2.2", title: "Project completion" },
            { code: "C2.3", title: "Quality of work" },
            { code: "C2.4", title: "Communication" },
            { code: "C2.5", title: "Maintenance" },
            { code: "C2.6", title: "Overall rating" },
            { code: "C2.7", title: "Comments and suggestions" },
            { code: "C2.8", title: "Signature" },
            { code: "C2.9", title: "Facebook review" },
            { code: "C2.10", title: "Google review" },
            { code: "C2.11", title: "Save survey" },
        ],
    },
    C1: {
        code: "C1",
        group: "C",
        title: "Project drafts",
        subtitle: "Customer blueprint approval",
        path: null,
        processStepId: 3,
        roles: "customer",
        subSteps: [
            { code: "C1.1", title: "Tick draft files" },
            { code: "C1.2", title: "Customer signature" },
            { code: "C1.3", title: "Customer approve" },
        ],
    },
    A4: {
        code: "A4",
        group: "A",
        title: "Collect 50%",
        subtitle: "Deposit collection",
        path: null,
        processStepId: 4,
        roles: "all",
        subSteps: [
            { code: "A4.1", title: "Amount" },
            { code: "A4.2", title: "Proof of payment" },
            { code: "A4.3", title: "Confirm payment" },
        ],
    },
    A5: {
        code: "A5",
        group: "A",
        title: "Customer Sign",
        subtitle: "Survey & sign off",
        path: null,
        processStepId: 9,
        roles: "all",
        subSteps: [
            { code: "A5.1", title: "Service rating criteria" },
            { code: "A5.2", title: "Overall rating" },
            { code: "A5.3", title: "Comments" },
            { code: "A5.4", title: "Confirmation order no" },
            { code: "A5.5", title: "Customer name" },
            { code: "A5.6", title: "Address" },
            { code: "A5.7", title: "Signature" },
            { code: "A5.8", title: "Clear signature" },
            { code: "A5.9", title: "Facebook review" },
            { code: "A5.10", title: "Google review" },
            { code: "A5.11", title: "Save survey" },
            { code: "A5.12", title: "Generate PDF" },
        ],
    },
    A6: {
        code: "A6",
        group: "A",
        title: "Complete Order",
        subtitle: "Salesman sign off",
        path: null,
        processStepId: 10,
        roles: "all",
        subSteps: [
            { code: "A6.1", title: "Complete order" },
            { code: "A6.2", title: "Commence date" },
            { code: "A6.3", title: "Confirm complete order" },
        ],
    },
    A7: {
        code: "A7",
        group: "A",
        title: "Warranty Request",
        subtitle: "Post-completion warranty",
        path: null,
        processStepId: null,
        roles: "all",
        subSteps: [
            { code: "A7.1", title: "Message" },
            { code: "A7.2", title: "Upload image" },
            { code: "A7.3", title: "Submit" },
        ],
    },
    A8: {
        code: "A8",
        group: "A",
        title: "Official Receipt",
        subtitle: "Download payment receipt",
        path: null,
        processStepId: null,
        roles: "all",
        subSteps: [
            { code: "A8.1", title: "Payment receipt" },
        ],
    },
    B1: {
        code: "B1",
        group: "B",
        title: "Draft Upload",
        subtitle: "Create blueprint",
        path: null,
        processStepId: 2,
        roles: "all",
        subSteps: [
            { code: "B1.1", title: "Upload blueprint" },
            { code: "B1.2", title: "Blueprint name" },
            { code: "B1.3", title: "Select product" },
            { code: "B1.4", title: "Select file" },
            { code: "B1.5", title: "Upload" },
            { code: "B1.6", title: "Submit draft" },
        ],
    },
    D1: {
        code: "D1",
        group: "D",
        title: "Purchasing",
        subtitle: "Materials ordering",
        path: null,
        processStepId: 5,
        roles: "all",
        subSteps: [
            { code: "D1.1", title: "Materials and add on" },
            { code: "D1.2", title: "Item code and item name" },
            { code: "D1.3", title: "Quantity" },
            { code: "D1.4", title: "Price" },
            { code: "D1.5", title: "Add to materials" },
            { code: "D1.6", title: "Measurements" },
            { code: "D1.7", title: "Company (supplier)" },
            { code: "D1.8", title: "Select" },
            { code: "D1.9", title: "Generate PO" },
            { code: "D1.10", title: "Submit purchase order" },
        ],
    },
    E1: {
        code: "E1",
        group: "E",
        title: "Production",
        subtitle: "Materials used",
        path: null,
        processStepId: 6,
        roles: "all",
        subSteps: [
            { code: "E1.1", title: "Materials" },
            { code: "E1.2", title: "Item code and item name" },
            { code: "E1.3", title: "Quantity" },
            { code: "E1.4", title: "Add to materials" },
            { code: "E1.5", title: "Submit production" },
            { code: "E1.6", title: "Complete production" },
        ],
    },
    E2: {
        code: "E2",
        group: "E",
        title: "Confirm Production",
        subtitle: "Production completed",
        path: null,
        processStepId: 7,
        roles: "all",
        subSteps: [],
    },
    F1: {
        code: "F1",
        group: "F",
        title: "Installer",
        subtitle: "Installation",
        path: null,
        processStepId: 8,
        roles: "all",
        subSteps: [
            { code: "F1.1", title: "New journal" },
            { code: "F1.2", title: "Select installers" },
            { code: "F1.3", title: "Installation date & time" },
            { code: "F1.4", title: "Journal type" },
            { code: "F1.5", title: "Create journal" },
            { code: "F1.6", title: "View journals" },
            { code: "F1.7", title: "Edit journal" },
            { code: "F1.8", title: "Delete journal" },
            { code: "F1.9", title: "Complete installation" },
        ],
    },
};

export const PROCESS_STEP_CODES = {
    1: "A2",
    2: "B1",
    3: "A3",
    4: "A4",
    5: "D1",
    6: "E1",
    7: "E2",
    8: "F1",
    9: "A5",
    10: "A6",
};

export const getStepGroup = (code) => {
    const step = WORKFLOW_STEPS[code];
    if (step?.group) return WORKFLOW_GROUPS[step.group];
    const parentCode = code?.split(".")[0];
    const parentStep = WORKFLOW_STEPS[parentCode];
    if (parentStep?.group) return WORKFLOW_GROUPS[parentStep.group];
    const groupKey = code?.charAt(0);
    return WORKFLOW_GROUPS[groupKey] || null;
};

export const getSubStepTitle = (code) => {
    if (!code?.includes(".")) return null;
    const parentCode = code.split(".")[0];
    const parent = WORKFLOW_STEPS[parentCode];
    return parent?.subSteps?.find((s) => s.code === code)?.title || null;
};

/** Help labels: restrict visible step-code groups by user type */
export const USER_TYPE_LABEL_GROUP = {
    staff: "A",
    drafter: "B",
    purchaser: "D",
    production: "E",
    installerManager: "F",
};

export const isStepCodeVisibleForUserType = (code, userType) => {
    const allowedGroup = USER_TYPE_LABEL_GROUP[userType];
    if (!allowedGroup) return true;
    return String(code || "").charAt(0) === allowedGroup;
};

export const NEW_USER_STEP_CODES = {
    name: "A1.1",
    ic: "A1.2",
    tin: "A1.3",
    email: "A1.4",
    phoneNumber: "A1.5",
    password: "A1.6",
    marketer: "A1.7",
    remarks: "A1.8",
    create: "A1.9",
};

export const POS_STEP_CODES = {
    selectProducts: "A2.1",
    glassRoof: "A2.2",
    price: "A2.3",
    addToCart: "A2.4",
    productInformation: "A2.5",
    discount: "A2.6",
    expenses: "A2.7",
    commission: "A2.8",
    threedDrawing: "A2.8.1",
    crane: "A2.8.2",
    customerDetails: "A2.9",
    dateOfIssue: "A2.10",
    customer: "A2.11",
    coNumber: "A2.12",
    deposit: "A2.13",
    secondPayment: "A2.14",
    thirdPayment: "A2.15",
    salesman: "A2.16",
    addressLine1: "A2.17",
    addressLine2: "A2.18",
    postalCode: "A2.19",
    city: "A2.20",
    state: "A2.21",
    billingLine1: "A2.22",
    billingLine2: "A2.23",
    billingPostcode: "A2.24",
    billingCity: "A2.25",
    billingState: "A2.26",
    estimatedInstallationDays: "A2.27",
    remark: "A2.28",
    leakageWarranty: "A2.29",
    acpWarranty: "A2.30",
    structureWarranty: "A2.31",
    glassWarranty: "A2.32",
    polycarbonateWarranty: "A2.33",
    metalDeckWarranty: "A2.34",
    aluminiumCBondWarranty: "A2.34.1",
    extraWarranty: "A2.35",
    paymentProof: "A2.36",
    sstIncluded: "A2.37",
    skipApproval: "A2.38",
    submitOrder: "A2.39",
};

export const BLUEPRINT_STEP_CODES = {
    uploadBlueprint: "B1.1",
    blueprintName: "B1.2",
    selectProduct: "B1.3",
    selectFile: "B1.4",
    upload: "B1.5",
    submitDraft: "B1.6",
};

export const CUSTOMER_DRAFT_STEP_CODES = {
    draftSelection: "C1.1",
    customerSignature: "C1.2",
    customerApprove: "C1.3",
};

export const CUSTOMER_SURVEY_STEP_CODES = {
    page: "C2",
    pricing: "C2.1",
    projectCompletion: "C2.2",
    qualityOfWork: "C2.3",
    communication: "C2.4",
    maintenance: "C2.5",
    overallRating: "C2.6",
    comments: "C2.7",
    signature: "C2.8",
    facebookReview: "C2.9",
    googleReview: "C2.10",
    saveSurvey: "C2.11",
};

export const PROJECT_DRAFT_STEP_CODES = {
    order: "A3.1",
    customer: "A3.2",
    customerApprove: "A3.3",
    approvalRequirements: "A3.4",
    tickAllDrafts: "A3.5",
    provideSignature: "A3.6",
    draftFiles: "A3.7",
    draftSelection: "A3.8",
    customerSignature: "A3.9",
    clearSignature: "A3.10",
    savedSignature: "A3.11",
};

export const PURCHASE_ORDER_STEP_CODES = {
    materialsAndAddOn: "D1.1",
    itemCodeAndName: "D1.2",
    quantity: "D1.3",
    price: "D1.4",
    addToMaterials: "D1.5",
    measurements: "D1.6",
    companySupplier: "D1.7",
    select: "D1.8",
    generatePO: "D1.9",
    submitPurchaseOrder: "D1.10",
};

export const PRODUCTION_STEP_CODES = {
    materials: "E1.1",
    itemCodeAndName: "E1.2",
    quantity: "E1.3",
    addToMaterials: "E1.4",
    submitProduction: "E1.5",
    completeProduction: "E1.6",
};

export const JOURNAL_STEP_CODES = {
    newJournal: "F1.1",
    selectInstallers: "F1.2",
    installationDateTime: "F1.3",
    journalType: "F1.4",
    createJournal: "F1.5",
    viewJournals: "F1.6",
    editJournal: "F1.7",
    deleteJournal: "F1.8",
    completeInstallation: "F1.9",
};

export const INSTALLMENT_STEP_CODES = {
    modal: "A4/6",
    amount: "A4.1",
    proofOfPayment: "A4.2",
    confirmPayment: "A4.3",
};

export const WARRANTY_REQUEST_STEP_CODES = {
    action: "A7",
    message: "A7.1",
    uploadImage: "A7.2",
    submit: "A7.3",
};

export const OFFICIAL_RECEIPT_STEP_CODES = {
    action: "A8",
    payment: "A8.1",
};

export const SURVEY_STEP_CODES = {
    serviceRating: "A5.1",
    overallRating: "A5.2",
    comments: "A5.3",
    orderNumber: "A5.4",
    customerName: "A5.5",
    address: "A5.6",
    signature: "A5.7",
    clearSignature: "A5.8",
    facebookReview: "A5.9",
    googleReview: "A5.10",
    saveSurvey: "A5.11",
    generatePdf: "A5.12",
};

export const HISTORY_TIMELINE_CODES = {
    projectCommenced: "A2",
    draftUploaded: "B1",
    draftRejected: "B1",
    blueprintApproved: "B1",
    salesmanRejectedDraft: "A3",
    salesmanApproved: "A3",
    customerRejectedDraft: "A3",
    customerApproved: "A3",
    purchaseOrderRejected: "D1",
    materialsPurchased: "D1",
    productionStarted: "E1",
    productionApproved: "E2",
    productionRejected: "E1",
    installationStarted: "F1",
    surveyCompleted: "A5",
    projectCompleted: "A6",
};

export const HISTORY_STEP_CODES = {
    completeOrder: "A6.1",
    commenceDate: "A6.2",
    confirmCompleteOrder: "A6.3",
    projectTimeline: "A6",
    financialSummary: "A2",
};

export const SIDEBAR_STEP_CODES = {
    newUser: "A1",
    pos: "A2",
    orders: ["A", "B", "C", "D", "E", "F", "G"],
};

export const getProcessStepCode = (processStepId) =>
    PROCESS_STEP_CODES[processStepId] || null;
